<template>
    <div class="panel">
        <div class="panel-heading message-header">
            Register a Phone
            <hcp-help>Press the "Send SMS" button to receive a text message with the code to put in the "Token" input.</hcp-help>
        </div>
        <div class="panel-block is-block">
            <error-notifications :errors="errors"></error-notifications>
            <hcp-notification type="is-success" :message.sync="successMessage"></hcp-notification>
            <form>
                <div class="field">
                    <label class="label" for="phoneNumber">Phone Number</label>
                    <div class="field has-addons">
                        <div class="control has-icons-left">
                            <input id="phoneNumber" class="input" type="text" name="phoneNumber" v-model="phoneNumber"
                                   required>
                            <span class="icon is-small is-left">
                            <i class="fas fa-phone"></i>
                        </span>
                        </div>
                        <div class="control">
                            <button class="button" @click.prevent="register">Send SMS</button>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <label class="label" for="token">Token</label>
                    <div class="field has-addons">
                        <div class="control has-icons-left">
                            <input id="token" class="input" type="number" name="token" v-model="token" required>
                            <span class="icon is-small is-left">
                            <i class="fas fa-sms"></i>
                        </span>
                        </div>
                        <div class="control">
                            <button class="button is-primary" @click.prevent="verify">Verify</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import urls from "../../urls";
    import ErrorNotifications from "heat-shared/src/components/ErrorNotifications";
    import HcpNotification from "../HcpNotification";
    import HcpHelp from "../HcpHelp";

    export default {
        name: "RegisterPhone",
        components: {HcpHelp, HcpNotification, ErrorNotifications},
        data: function () {
            return {
                'errors': [],
                'id': '',
                'phoneNumber': '',
                'token': '',
                'successMessage': '',
            }
        },
        methods: {
            async register() {
                if (!this.phoneNumber) {
                    this.errors = ['You must enter a Phone Number.'];
                    return
                }
                this.errors = [];
                try {
                    let response = await axios.post(urls['two_factor_device'],
                        {
                            'type': 'sms',
                            'data': this.phoneNumber,
                        },
                        {'Content-type': 'application/json'});
                    this.id = response.data['id'];
                    this.successMessage = "SMS sent. It may take several minutes for you to receive it.";
                } catch (error) {
                    if (error.response.status === 500) {
                        this.errors.push([`Oops: Our system broke while trying to do that!<br>${error.response.data}`]);
                        return;
                    }
                    this.errors = Object.values(error.response.data);
                }
            },
            async verify() {
                if (!this.id) {
                    this.errors = ['Can not verify an SMS for a phone that has not sent one yet.'];
                    return
                }
                this.errors = [];
                try {
                    let response = await axios.post(urls['two_factor_device'] + this.id,
                        {
                            'id': this.id,
                            'token': this.token,
                        },
                        {'Content-type': 'application/json'});
                    if (response.data['Success'] === true) {
                        this.successMessage = "You have successfully added a Phone.";
                        this.$store.commit('clearMessages');
                        await this.$store.dispatch('user/getTwoFactorDevices');
                        let redirect_to = this.$route.query.next || null;
                        if(redirect_to !== null){
                            this.$router.push(redirect_to);
                        }
                    }
                } catch (error) {
                    if (error.response.status === 500) {
                        this.errors.push([`Oops: Our system broke while trying to do that!<br>${error.response.data}`]);
                        return;
                    }
                    this.errors = Object.values(error.response.data);
                }
            }
        }
    }
</script>

<style scoped>

</style>